import { render, staticRenderFns } from "./SplitProductsModal.vue?vue&type=template&id=f88221d6"
import script from "./SplitProductsModal.vue?vue&type=script&lang=js"
export * from "./SplitProductsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports